{
  "title": "Udostępnienie lokalizacji pozwala przyspieszyć proces zameldowania",
  "body": "Przepraszamy, ale nie możemy ukończyć Twojego zameldowania bez dostępu do Twojej lokalizacji. Proszę przyznać dostęp do lokalizacji, aby kontynuować. Używamy Twojej lokalizacji wyłącznie w celach zameldowania w magazynie i nie przechowujemy ani nie udostępniamy Twoich danych lokalizacyjnych stronom trzecim.",
  "shareLocation": "Udostępnij moją lokalizację"
}
